import React, {Component} from "react"
import {Link} from "react-router"

class FeaturedListItem extends Component {
    render() {
        return (
            <div className="col-sm-6">
                <ul className="featured-list featured-list-bordered">
                    <li>
                        <div className="featured-list-icon">
                            <span className={`icon featured-list-item-icon icon-${this.props.icon}`} />
                        </div>
                        <h3>{this.props.title}</h3>
                        <p>
                            {this.props.children}
                        </p>
                        <Link to={this.props.linkTo} className="btn btn-info-outline btn-sm">{this.props.linkText}</Link>
                    </li>
                </ul>
            </div>
        )
    }
}

FeaturedListItem.propTypes = {
    title: React.PropTypes.string,
    icon: React.PropTypes.string,
    linkText: React.PropTypes.string,
    linkTo: React.PropTypes.string
};

export default FeaturedListItem;



// WEBPACK FOOTER //
// ./src/modules/common/FeaturedListItem.js